<template>
  <export-pdf :loading="loading" :filename="`resultado_destaque_${campaign._id}`" title="Resultado de destaque" :subtitle="title">
    <mf-pdf-item :title="title" :description="description" :name="$getLoggedUser().client">
      <campaign-info-cards :campaign="campaign" :products="products" />
    </mf-pdf-item>
    <mf-pdf-item title="Métricas do destaque" :name="$getLoggedUser().client">
      <campaign-metrics :metrics="campaignCardsMetrics" />
    </mf-pdf-item>
    <mf-pdf-item title="Resultados por perfil" :name="$getLoggedUser().client">
      <slot name="profile-table"></slot>
    </mf-pdf-item>
    <mf-pdf-item title="Total dos resultados por produto" :name="$getLoggedUser().client">
      <slot name="total-products-table"></slot>
    </mf-pdf-item>
    <mf-pdf-item title="Resultados por produto" description="Exibição de até 10 resultados por produto" :name="$getLoggedUser().client">
      <slot name="products-table"></slot>
    </mf-pdf-item>
  </export-pdf>
</template>

<script>
import { QUERY_GET_ACCOUNT_IMAGES } from '@/modules/configuracoes-admin/graphql/index.js'
import ExportPdf from '@/components/ExportPdf.vue'
import CampaignInfoCards from './CampaignInfoCards.vue'
import CampaignMetrics from './CampaignMetrics.vue'

export default {
  name: 'HighlightResultsPdf',
  components: {
    ExportPdf,
    CampaignInfoCards,
    CampaignMetrics,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    activatable: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    campaignCardsMetrics: {
      type: Array,
      default: () => [],
    },
    campaign: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    title() {
      return this.campaign.name
    },
    description() {
      return this.campaign.description
    },
    logoImage() {
      return this.hotsite?.images?.finish?.logo
    },
  },
  apollo: {
    hotsite: {
      query: QUERY_GET_ACCOUNT_IMAGES,
      fetchPolicy: 'network-only',
      update({ account }) {
        return account?.channels?.hotsite?.configuration?.assets
      },
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep .full-width {
  width: 100%;
}

.funnel-container,
.units-chart-container {
  margin-top: -50px;
  width: 95%;
}
.units-chart-container {
  height: 400px;
}
</style>
